import {
  ExpenseCodePayload,
  ExpenseCodeResponse,
  ExpenseCodesResponse,
  Id,
  Options,
  Resource
} from 'services/api';

import Company from './Company.service';

export default class ExpenseCode extends Company {
  private static instance: ExpenseCode;

  private constructor(options: Options) {
    /* istanbul ignore next */
    super(options);
  }

  /**
   * This return the singleton instance of the class
   * @param {Options} options
   */
  public static getInstance(options: Options) {
    if (!this.instance) {
      this.instance = new this(options);
    }
    return this.instance;
  }

  /**
   * Get a list of company Expense Codes
   * @param {Id} [company_id] (optional) company id
   */
  list(params?: Record<string, any>, company_id?: Id) {
    return this.getEntities<ExpenseCodesResponse>(
      Resource.ExpenseCodes,
      params,
      company_id
    );
  }

  /**
   * Get a expense code by id
   * @param {Id} id expense code id
   * @param {Id} [company_id] (optional) company id
   */
  get(id: Id, company_id?: Id) {
    return this.getEntity<ExpenseCodeResponse>(
      Resource.ExpenseCode,
      id,
      company_id
    );
  }

  /**
   * Create an expense code
   * @param {ExpenseCodePayload} payload
   * @param {string} payload.name expense code name
   * @param {Id} [company_id] (optional) company id
   */
  create(payload: ExpenseCodePayload, company_id?: Id) {
    return this.createEntity<ExpenseCodeResponse, ExpenseCodePayload>(
      Resource.ExpenseCode,
      payload,
      company_id
    );
  }

  /**
   * Delete an expense code by id
   * @param {Id} id expense code id
   * @param {Id} [company_id] (optional) company id
   */
  delete(id: Id, company_id?: Id) {
    return this.deleteEntity(Resource.ExpenseCode, id, company_id);
  }

  /**
   * Update an expense code by id
   * @param {Id} id resource id
   * @param {ExpenseCodePayload} payload
   * @param {string} payload.name expense code name
   * @param {Id} [company_id] (optional) company id
   */
  update(id: Id, payload: ExpenseCodePayload, company_id?: Id) {
    return this.updateEntity<ExpenseCodePayload>(
      Resource.ExpenseCode,
      id,
      payload,
      company_id
    );
  }
}
